import { createFileRoute } from "@tanstack/react-router";
import { AgentConnectDetail } from "@/components/agents/agent-connect-pages";
import { OwnerWorkspaceGate } from "@/components/owner-workspace-gate";

export const Route = createFileRoute("/$owner/agents/connect/$clientId")({
	component: AgentConnectDetailPage,
});

function AgentConnectDetailPage() {
	const { owner, clientId } = Route.useParams();
	return (
		<OwnerWorkspaceGate owner={owner}>
			{({ ownerSlug }) => (
				<AgentConnectDetail owner={ownerSlug} clientId={clientId} />
			)}
		</OwnerWorkspaceGate>
	);
}
